import {Component, OnInit} from "@angular/core";
import {StepComponent} from "../../step/step.component";
import {EingabeForm} from "./eingabe.form";
import {Step, StepService} from "../../services/step.service";
import {FoerdermittelcheckAnfrage} from "../anfrage/foerdermittelcheck.anfrage";
import {Router} from "@angular/router";
import {FoerdermittelcheckRequestService} from "../services/request.service";
import {ElementService} from "../../services/element.service";
import {PortalService} from "../../services/portal.service";

/**
 * Overwrite the Generic step component for the first section fo the foerdermittelcheck.
 *
 * @inheritDoc
 */
@Component({
    selector: 'app-step-eingabe',
    templateUrl: '../../step/step.component.html',
    standalone: false
})

export class EingabeStepComponent extends StepComponent implements OnInit {

  /**
   * (input) data of the user
   */
  anfrage: FoerdermittelcheckAnfrage;

  /**
   * @inheritDoc
   */
  formConfig: EingabeForm;

  /**
   * Overwrite the label prefix.
   */
  textkeyPrefix = 'foerdermittelcheck';

  /**
   * Set to true if userinput is only elektromobilitaet
   */
  isOnlyElektro: boolean = false;

  /**
   * constructor
   *
   * @param stepService
   * @param router
   * @param requestService
   * @param elementService
   * @param portalService
   */
  constructor(protected stepService: StepService, protected router: Router, protected requestService: FoerdermittelcheckRequestService, protected elementService: ElementService, protected portalService: PortalService) {
    super(stepService, router, elementService);
  }

  /**
   * @inheritDoc
   */
  ngOnInit() {
    // add the correct form config that we need in this steps and init the parent form
    this.formConfig = new EingabeForm();
    super.ngOnInit();

    // get the current input data and preset it
    this.anfrage = this.requestService.getAnfrage();
    this.formConfig.anfrage = this.anfrage;

    this.formConfig.setStepComponent(this);
    this.formConfig.setData(this.anfrage.userInput);

    //check if userinput is only elektromobilitaet
    this.isOnlyElektro = (this.anfrage?.gefoerdertWird?.length === 1 && this.anfrage?.gefoerdertWird[0] === 'elektromobilitaet');

    //check in which path we are and set global variable
    window['focPath'] = this.isOnlyElektro ? 'elektro' : 'bau';
    //update navigation
    this.stepService.updateNavigation.emit();

    // update the previous step
    this.onStepUpdate();

    // if no next step then next step is result page
    if(!this.steps?.nextStep) {
      this.steps.nextStep = new Step('ergebnis', '/foerdermittelcheck/ergebnis/foerdermittel');
    }

    //if we click on insulation in nav bar, but there is no insulation in measures, divert to step heating
    if(this.anfrage?.measures) {
      if(!Object.keys(this.anfrage.measures).includes('insulation') && this.steps?.currentStep?.name === 'massnahmen/insulation') {
        this.router.navigateByUrl( this.portalService.currentPortalId + '/foerdermittelcheck/eingabe/massnahmen/heating');
      }
      //if we click on heating_optimization in nav bar, but there is no heating_optimization in measures, divert to step additional_systems
      if(!Object.keys(this.anfrage.measures).includes('heating_optimization') && this.steps?.currentStep?.name === 'zusatzmassnahmen/heating_optimization') {
        this.router.navigateByUrl( this.portalService.currentPortalId + '/foerdermittelcheck/eingabe/zusatzmassnahmen/additional_systems');
      }
      //if we click on energetic_optimization in nav bar, but there is no energetic_optimization in measures, divert to step additional_measures
      if(!Object.keys(this.anfrage.measures).includes('energetic_optimization') && this.steps?.currentStep?.name === 'energie/energetic_optimization') {
        this.router.navigateByUrl( this.portalService.currentPortalId + '/foerdermittelcheck/eingabe/zusatzmassnahmen/additional_measures');
      }
    }

    // init error placeholder
    this.initErrorPlaceholder();
  }


  /**
   * @inheritDoc
   */
  saveData(data: { [key: string]: any }) {
    // merge the data with the existing data
    this.anfrage.userInput = {...this.anfrage.userInput, ...data};
    this.requestService.setAnfrage(this.anfrage);

    // save the data also to the server
    this.requestService.saveDataToServer();

    super.saveData(data);
  }

  /**
   * Return the next step from a step list
   */
  getNextStepFromList(stepList: Step[]): any {
    // set all data again in the form to avoid using old data for toggle fields
    if (this.anfrage?.userInput && this.formConfig) {
      this.formConfig.updateFields(this.anfrage.userInput);
      // save the data again. In some case some fields are auto updated
      this.saveData({});
    }

    return super.getNextStepFromList(stepList);
  }

  /**
   * @inheritDoc
   */
  onSubmit(): void {
    if((this.isOnlyElektro && this.steps?.currentStep?.name === 'gebaeude/basisinformationen/3') ||
      this.steps?.currentStep?.name === 'nutzung/basisinformationen/7') {
      this.saveData(this.formConfig.getData());
      this.getFundingMeasures();
      return;
    }

    super.onSubmit();
  }

  moveToNextStep() {
    const nextStep = this.getNextStepFromList(this.steps.nextStepList);

    //if no next step, get programs from backend and move to result page
    if(!nextStep || this.steps?.currentStep?.name === 'energie/electric_mobility') {
      // reached end, get programs
      this.getFundingPrograms();
      return;
    }
    super.moveToNextStep();

  }

  /**
   * @inheritDoc
   */
  onStepUpdate() {
    super.onStepUpdate();

    // set previous step on first step to go back to 'einstieg' page
    if(this.steps?.currentStep?.name === 'foerdernehmer/basisinformationen/1') {
      this.previousStep = new Step('einstieg', '../../../../einstieg');
      //remove helptext for this step
      this.hasHelp =false;
    }
    //set inline help text after setting the option from backend
    this.setAutoSubmitAndInlineHelp();

    // change textkeys if gebaeudetyp is nwg
    if(this.anfrage?.userInput?.gebaeudetyp === 'nichtwohngebaeude') {
      // change helptext on step additional_systems
      if(this.steps?.currentStep?.name === 'zusatzmassnahmen/additional_systems') {
        this.helpTextkey += '.nwg';
      }
      // add labelpostfix on step heating
      if(this.steps?.currentStep?.name === 'massnahmen/heating'){
        this.formConfig.labelPostfix = '.nwg';
        this.helpTextkey += '.nwg';
      }
    }

  }

  /**
   * @inheritDoc
   */
  setAutoSubmitAndInlineHelp() {
    super.setAutoSubmitAndInlineHelp();
    // After calling getFundingMeasures() we get back the right measures from the API and set the next step/path.
    // In this case the next step/path is being skipped by autoSubmit, so we deactivate the autoSubmit
    if(this.steps?.currentStep?.name === 'massnahmen/heating' ||
      this.steps?.currentStep?.name === 'massnahmen/insulation' ||
      this.steps?.currentStep?.name === 'energie/electric_mobility') {
      this.autoSubmit = false;
    }
  }

  /**
   * get the funding measures from the backend and throw form error if there are no funding measures
   */
  getFundingMeasures(): void {
    // create a funding path with gefoerdertWird + gebaeudetyp and save to anfrage
    this.anfrage.fundingPath = this.anfrage.gefoerdertWird.join('_') + '_' + this.anfrage.userInput.gebaeudetyp;
    this.loading = true;

    // send data to backend
    this.requestService.backendService.getRequestId().subscribe(requestId => {
      // recalculate measure
      this.requestService.backendService.measures(this.anfrage, requestId).subscribe(data => {
        this.anfrage.measures = data.result.data;
        this.formConfig.anfrage = this.anfrage;

        this.formConfig.setStepComponent(this);
        this.formConfig.setData(this.anfrage.userInput);
        // delete measure input values
        for(const input of Object.keys(this.anfrage.userInput)) {
          // exclude basic fields from deleting input values
          if(this.formConfig.basicFields.indexOf(input) === -1) {
            delete this.anfrage.userInput[input];
          }
        }

        this.requestService.setAnfrage(this.anfrage);

        // define the next path
        this.getNextPath();
        this.loading = false;

      }, (error) => {
        const errors = error?.error?.result?.status?.errors ?? null;
        this.formError = errors?.length > 1 ? (errors[0].code + '.several.steps') : (errors[0].code + '.' + errors[0].affected_fields[0]);
        this.loading = false;
      });
    });
  }

  /**
   * get the funding programs from the backend and throw form error if there are no funding programs
   */
  getFundingPrograms(): void {
    this.loading = true;
    //send data to backend
    this.requestService.backendService.getRequestId().subscribe(requestId => {
      // recalculate programs
      this.requestService.backendService.programs(this.anfrage, requestId).subscribe(data => {
        this.anfrage.programs = data?.programs?? [];
        //save program ids
        this.anfrage.programIds = [];
        for(const program of this.anfrage.programs) {
          this.anfrage.programIds.push(program.OID);
        }

        this.anfrage.report = data?.report?? '';
        this.anfrage.debug = data?.debug?? [];

        this.requestService.setAnfrage(this.anfrage);

        this.loading = false;
        this.router.navigateByUrl(this.portalService.currentPortalId + ('/foerdermittelcheck/ergebnis/foerdermittel'));

      }, () => {
        this.formError += '.connection';
        this.loading = false;
      });

    }, () => {
      // an error occured while talking to the backend.
      this.formError += '.connection';
      this.loading = false;
    });
  }

  /**
   * get and navigate to the next path, depending on input field gefoerdertWird and gebaeudetyp
   */
  getNextPath() {
    let nextPath: string = null;
    //set the right next path depending on the measures from backend
    if(this.isOnlyElektro) {
      nextPath = this.portalService.currentPortalId + '/foerdermittelcheck/eingabe/energie/electric_mobility';
    }
    //next path when altbau selected
    else if(this.anfrage?.gefoerdertWird?.includes('altbau') &&
      this.anfrage?.userInput?.gebaeudetyp !== 'nichtwohngebaeude') {
      nextPath = this.portalService.currentPortalId + '/foerdermittelcheck/eingabe/massnahmen/insulation';
    }
    else {
      nextPath = this.portalService.currentPortalId + '/foerdermittelcheck/eingabe/massnahmen/heating';
    }

    this.router.navigateByUrl(nextPath, {state: {lastStep: this.router.url}});
  }

  /**
   * inits placeholder for error messages
   */
  initErrorPlaceholder(): void {
    this.stepErrorPlaceholder = {
      portalId: this.portalService?.currentPortalId
    }
  }




}
